import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterTextValue,
  UniversalFilterTextModes,
  UniversalFilterTextFilterOptions,
  UniversalFilterTextOnChange
} from './UniversalFilterText.types';

import { useUniversalFilterText } from './hooks/useUniversalFilterText';

import { UniversalFilterTextInput } from '../../helpers/UniversalFilterTextInput';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterTextProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterTextValue;
  i18nName: I18nText;
  options?: UniversalFilterTextFilterOptions;
  autoFocus?: boolean;
  onChange: UniversalFilterTextOnChange;
}

function UniversalFilterText({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  options,
  autoFocus,
  onChange
}: UniversalFilterTextProps) {
  const { modeOptions, filterState, handleModeChange, handleTextChange } =
    useUniversalFilterText({
      filterStateCacheKey,
      filterValue,
      options,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterTextModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [
          UniversalFilterTextModes.CONTAINS,
          UniversalFilterTextModes.IS,
          UniversalFilterTextModes.IS_NOT,
          UniversalFilterTextModes.STARTS_WITH,
          UniversalFilterTextModes.ENDS_WITH
        ],
        filterState.mode
      ) ? (
        <UniversalFilterTextInput
          key={filterState.mode}
          value={filterState.text}
          autoFocus={autoFocus}
          onChange={handleTextChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterText;
